  <!-- 其他支出 -->
  <template>
  <div>
    <!-- 按钮列表 -->
    <butotn-plug :btndata="BTN_CONFIG" @btnEvent="callBack" @clearBtns="clearBtns" @moreParam="moreParam" @queryBtn_ok="queryBtn_ok" ref="btnList" />
    <!-- 查询列表 -->
    <input-plug ref="queryForm" :form-config="baseConfig" :form-data="queryData" :More="isHaseMore" @changeCallback="rowCallback">
      <template slot="time1">
        <multitime :timeType="timeType" :timeTypes="timeTypes" :startTime="startTime_a" :endTime="endTime_a" @timestatus="timestatus" @queryBtn_ok="queryBtn_time" />
      </template>
    </input-plug>
    <!-- 表格 -->
    <table-plug :tableConfig="tableConfig" :defaulthead="myTableHeard" :totals="totalArr" ref="mytable" @selectChange="handleSelectionChange" @rowCallback="rowCallback" />
    <!-- 分页 -->
    <paging ref="pags" :pageNum="pageStart" :total="pageCount" :size="pageTotal" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"></paging>
    <!--        自定义表头           -->
    <!-- 
        * 表头的方法提取到Mixin.js里面了
          show_sortTableHeard、allCheck、originalTabelHeadeTitle、selectLength
          confirmOk、checktab、checkAll、closeDias、cancelSortHeard
    -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    />

    <!-- ======================打印组件======================== -->
    <prints
      :diaWidth_print="diaWidth_print"
      :dialogTitle_print="dialogTitle_print"
      :isShowDialog_print="isShowDialog_print"
      :dataList="dataList"
      :topData="topData"
      @handleCloseDia_print="handleCloseDia_print"
      @diaConfirmBtn_print="diaConfirmBtn_print"
    ></prints>

    <!-- 选择打印模板 -->
    <printDialog
      :dialogFrom="dialogFrom"
      ref="dialogSelect"
      title="选择模板"
      icon="el-icon-printer"
      modelTypeVal="其他支出模块"
      @handleCreated="handleCreated"
      @handleView="handleView"
      @handleEdit="handleEdit"
      @handleOk="handleOk"
    ></printDialog>

    <!-- 创建和使用模板 -->
    <printSys :printForm="printForm" :title="printTitle" icon="el-icon-printer" @handleClose="handlePrintSysClose">
      <printSysContent :printType="printType" :modelObj="modelObj" :modelClassName="modelClassName" :selectTableData="selectTableData"></printSysContent>
    </printSys>

    <!-- 打印系统数据接口的className -->
    <classNameDialog
      :diaWidth="classNameDiaWidth"
      :dialogTitle="classNameDialogTitle"
      :isShowDialog="isShowClassNameDialog"
      @handleCloseDia="handleCloseClassNameDia"
      @diaCancelBtn="classNameDiaCancelBtn"
      @diaConfirmBtn="classNameDiaConfirmBtn"
    >
      <el-select v-model="modelClassName" placeholder style="width: 100%">
        <el-option v-for="(value, key) in classNameArr" :key="key" :label="value.name" :value="value.val"></el-option>
      </el-select>
    </classNameDialog>
    <!-- ======================打印组件======================== -->
    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
      <!-- 查询列表 -->
      <input-plug ref="queryForm" :form-config="baseConfig" :form-data="queryData" :More="true" @changeCallback="rowCallback">
        <template slot="time1">
          <multitime :timeType="timeType" :timeTypes="timeTypes" :startTime="startTime_a" :endTime="endTime_a" @timestatus="timestatus" @queryBtn_ok="queryBtn_time" />
        </template>
      </input-plug>
    </exportCompoent>
  </div>
</template>
   <script >
import { mixin_1 } from "@/assets/js/Mixins/mixin";
import { otherMixin } from "@/pages/FinancialManagement/OtherIncomeMOD/OtherIncomMixin";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import ButotnPlug from "@/components/Modules/ButtonPlug.vue";
import InputPlug from "@/components/Modules/InputPlug.vue";
import multitime from "@/components/multiTime.vue";
import paging from "@/components/pagings.vue"; //分页组件
import TablePlug from "@/components/Modules/TablePlug.vue";
import MyDialog from "@/components/Dialog.vue";
import DiaForm from "@/pages/VMS/VMSConpon/DiaForm.vue";
import ImgUpload from "@/components/Modules/ImgUpload.vue";
import RecordTable from "@/pages/FinancialManagement/FinancialWriteOff/FMMOD/RecordTable.vue";
import { mixin_print } from "@/assets/js/Mixins/mixinPrint";
import exportjs from "@/assets/js/Mixins/export.js"; //导出的公共js
export default {
  mixins: [mixin_1, otherMixin, mixin_print, exportjs],
  components: {
    ButotnPlug,
    InputPlug,
    multitime,
    TablePlug,
    paging,
    sorttable,
    MyDialog,
    DiaForm,
    ImgUpload,
    RecordTable,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "其他支出列表", //导出时默认文件名
        apiName: "/admin/v3/finance/other/getOtherOutList", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "GET", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      myTableHeard: [],
      pageGroupName: "OtherExpenses",
      tabelHeadeTitle: [
        {
          name: "操作",
          field: "edit",
          Buttons: [
            {
              method: "open_m",
              methodName: "打开",
              permissVal: "admin:other_finance:getOtherOutDetail",
            },
          ],
        },

        {
          name: "其他收支单号",
          field: "number",
          width: "130", // default：120
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计 default：false
          isSort: false, //表格设置里面是否可以排序 default：false
        },
        {
          name: "收支方向",
          field: "inoutStatusShow",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "业务网点",
          field: "businessDeptName",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "发生日期",
          field: "occurrenceTime",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "结算对象类型",
          field: "objectStatus",
          width: "130",
          sort: 6,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "结算对象",
          field: "objectName",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "费项类型",
          field: "itemCategoryName",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "费项",
          field: "itemServiceName",
          sort: 18,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "发生金额",
          field: "amount",
          sort: 19,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "付款方式",
          field: "settlementMethod",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "总重量",
          field: "totalWeight",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "总体积",
          field: "totalVolume",
          sort: 2,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "来源单号",
          field: "documentNumber",
          sort: 2,
          isShow: true,
          isTotal: false,
          isSort: false,
        },

        {
          name: "车牌号码",
          field: "carNumber",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "是否需要核销",
          field: "isSettlementShow",
          width: "130",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "摘要",
          field: "remark",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "票据类型",
          field: "invoiceType",
          sort: 120,
          isShow: true,
          isTotal: false,
          isSort: false,
        },

        {
          name: "票据号",
          field: "invoiceNumber",
          sort: 6,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "经办人",
          field: "handelObjectName",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },

        {
          name: "经办时间",
          field: "handelTime",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "过账状态",
          field: "isPostingShow",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "过账人",
          field: "postingUserName",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "过账时间",
          field: "postingTime",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "创建时间",
          field: "createTime",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "创建人",
          field: "createUserName",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
      ],
      tableType: "OtherExpenses",
      sortName: "其他支出", //  排序名
      // 按钮配置
      BTN_CONFIG: [
        {
          name: "新建",
          method: "create_m",
        },
        {
          name: "打开",
          method: "open_m",
        },
        {
          name: "过账",
          method: "Posting",
        },
        {
          name: "反过账",
          method: "UnPosting",
        },
        {
          name: "批量过账",
          method: "Postings",
        },
        {
          name: "批量反过账",
          method: "UnPostings",
        },
        {
          name: "批量删除",
          method: "Deletes",
        },
        {
          name: "表格设置",
          method: "SetTable",
          permissVal: "aaaaa",
        },
        {
          name: "导出",
          method: "exportData",
          permissVal: "aaaaa",
        },
        {
          name: "打印",
          method: "printEvent",
          permissVal: "aaaaa",
        },
      ],

      // 打印插件 每个页面不一样的
      // 模板className
      idarrs: [],
      classNameArr: [
        {
          name: "费用报销-单条",
          val: "com.bami.service.tms.v3.admin.print.vo.AdminOtherFinanceOnePrintDataV3tmsVo",
        },
        {
          name: "费用报销-多条",
          val: "com.bami.service.tms.v3.admin.print.vo.AdminOtherFinanceMorePrintDataV3tmsVo",
        },
      ],
      // 默认的模板类型
      modelClassName: "",
    };
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle;
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1;
      }
      this.tabelHeadeTitle = arr;
    }
    //获取默认表头 页面有这四个字段 myTableHeard,sortName,tabelHeadeTitle,totalArr
    // this.$TOOLS.getGroupFindFieldSort(this, this.pageGroupName);
  },
  created() {},
  methods: {
    // ==================打印插件==================
    // 打印按钮
    printEvent(val) {
      let idarr = [];
      if (val) {
        idarr.push(val.otherId);
        this.selectTableData = [val];
      } else {
        if (this.selectTableData.length < 1) {
          this.$message.error("请选择需要打印的数据");
          return false;
        }
        idarr = this.selectTableData.map((item) => {
          return item.otherId;
        });
      }
      this.idarrs = idarr;
      console.log("this.idarr", this.idarrs);

      window.sessionStorage.setItem(
        "set_PrintSelectTableData",
        JSON.stringify(idarr)
      );
      this.dialogFrom.dialogVisible = true;
    },
    // 打印预览模板
    handleView(obj) {
      let hiprintTemplate = new hiprint.PrintTemplate({
        template: JSON.parse(obj.content),
      });
      let idarr = this.idarrs || [];
      console.log("aaa", idarr);
      // for (let i = 0; i < this.selectTableData.length; i++) {
      //   idarr.push(this.selectTableData[i].dispatchId);
      // }

      if (obj.className == this.classNameArr[0].val) {
        // 费用报销-单条
        this.$API
          .getOtherFinanceOnePrintData({
            otherFinanceIds: idarr,
          })
          .then((res) => {
            if (res.status == 200) {
              if (res.data && res.data.status == "success") {
                const result = res.data.result;
                hiprintTemplate.print(result, {});
              }
            }
          });
      } else if (obj.className == this.classNameArr[1].val) {
        // 费用报销-多条
        this.$API
          .getOtherFinanceMorePrintData({
            otherFinanceIds: idarr,
          })
          .then((res) => {
            if (res.status == 200) {
              if (res.data && res.data.status == "success") {
                const result = res.data.result;
                hiprintTemplate.print(result, {});
              }
            }
          });
      }
    },
    // 打印-确定模板的数据
    handleOk(obj) {
      let hiprintTemplate = new hiprint.PrintTemplate({
        template: JSON.parse(obj.content),
      });
      let idarr = this.idarrs || [];
      if (obj.className == this.classNameArr[0].val) {
        this.$API
          .getOtherFinanceOnePrintData({
            otherFinanceIds: idarr,
          })
          .then((res) => {
            if (res.status == 200) {
              if (res.data && res.data.status == "success") {
                const result = res.data.result;
                hiprintTemplate.print(result, {});
              }
            }
          });
      } else if (obj.className == this.classNameArr[1].val) {
        // 获取发车配载清单
        this.$API
          .getOtherFinanceMorePrintData({
            otherFinanceIds: idarr,
          })
          .then((res) => {
            if (res.status == 200) {
              if (res.data && res.data.status == "success") {
                const result = res.data.result;
                hiprintTemplate.print(result, {});
              }
            }
          });
      }
    },

    // ==================打印插件==================

    // 导出
    exportData() {
      // this.$COMAPI.exportBtn({
      //   pageGroupName: this.pageGroupName, //页面标识
      //   myTableHeard: this.myTableHeard, //表头数组
      //   className: this.className, //列表标识
      //   tableData: this.tableConfig.tableData, //数据源
      //   sheetName: "表名(暂无效)", //表名
      // });
      this.isShowDialog_dc = true;
    },

    // 获取其他支出列表
    GetData() {
      let startTime = this.startTime_a ? this.startTime_a + " 00:00:00" : "";
      let endTime = this.endTime_a ? this.endTime_a + " 23:59:59" : "";
      this.queryData.pageStart = this.pageStart;
      this.queryData.pageTotal = this.pageTotal;

      if (this.timeType === "0") {
        this.queryData.startCreateTime = startTime;
        this.queryData.endCreateTime = endTime;
        this.queryData.startOccurrenceTime = "";
        this.queryData.endOccurrenceTime = "";
      }
      if (this.timeType === "1") {
        this.queryData.startOccurrenceTime = startTime;
        this.queryData.endOccurrenceTime = endTime;
        this.queryData.startCreateTime = "";
        this.queryData.endCreateTime = "";
      }

      this.$API.OtherOutList(this.queryData).then((res) => {
        if (res.data.status === "success") {
          this.className = res.data.result.className || "";
          this.tableConfig.tableData = res.data.result.data || [];
          this.pageCount = res.data.result.pageCount || 0;
          this.$nextTick(() => {
            this.fetTableHeight();
          });
        } else {
          this.$message.error(`${res.data.message}---其他支出列表`);
        }
      });
    },
    // 新建
    create_m() {
      this.$router.push("/FM/NewOtherExpenses/1");
      this.selectTableData.length = 0;
    },
    // 修改
    open_m(data) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length !== 1) {
        this.$message.error("请选择一条数据进行操作");
        return false;
      } else {
        this.$router.push({
          path: "/FM/NewOtherExpenses/1",
          query: {
            otherId: this.selectTableData[0].otherId,
          },
        });
      }
      this.selectTableData.length = 0;
    },
    // 过账
    Posting(data) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length !== 1) {
        this.$message.error("请选择一条数据进行操作");
        return false;
      } else {
        this.$router.push({
          path: "/FM/NewOtherExpenses/1",
          query: {
            otherId: this.selectTableData[0].otherId,
          },
        });
      }
      this.selectTableData.length = 0;
    },
    // 反过账
    UnPosting(data) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length < 1) {
        this.$message.error("请至少选择一条数据进行操作");
        return false;
      } else {
        this.$confirm(`确认要反过账所选数据?`, "提示:")
          .then((res) => {
            let params = {
              otherIds: new Array(),
            };
            this.selectTableData.map(function (val, i) {
              params.otherIds.push(val.otherId);
            });

            // 反过账
            this.$API.unPostingOtherOut(params).then((r) => {
              if (r.data.status === "success") {
                this.GetData();
                this.$message.success(r.data.message);
              }
            });
          })
          .catch((err) => {
            if (data) this.selectTableData.length = 0;
          });
      }
    },
    // 批量过账
    Postings() {
      if (!this.selectTableData.length) {
        this.$message.error("请至少选择一条数据进行操作");
        return false;
      } else {
        this.$confirm(`确认要批量过账所选数据?`, "提示:")
          .then((res) => {
            let params = {
              otherIds: new Array(),
            };
            this.selectTableData.map(function (val, i) {
              params.otherIds.push(val.otherId);
            });
            this.$API.batchPostingOtherOut(params).then((r) => {
              if (r.data.status === "success") {
                this.GetData();
                this.$message.success(r.data.message);
              }
            });
          })
          .catch((err) => {
            if (data) this.selectTableData.length = 0;
          });
      }
    },
    // 批量反过账
    UnPostings() {
      if (!this.selectTableData.length) {
        this.$message.error("请至少选择一条数据进行操作");
        return false;
      } else {
        this.$confirm(`确认要批量反过账所选数据?`, "提示:")
          .then((res) => {
            let params = {
              otherIds: new Array(),
            };
            this.selectTableData.map(function (val, i) {
              params.otherIds.push(val.otherId);
            });
            this.$API.unPostingOtherOut(params).then((r) => {
              if (r.data.status === "success") {
                this.GetData();
                this.$message.success(r.data.message);
              }
            });
          })
          .catch((err) => {
            if (data) this.selectTableData.length = 0;
          });
      }
    },
    // 批量删除
    Deletes() {
      if (!this.selectTableData.length) {
        this.$message.error("请至少选择一条数据进行操作");
        return false;
      } else {
        this.$confirm(`确认要批量删除所选数据?`, "提示:")
          .then((res) => {
            let params = {
              otherIds: new Array(),
            };
            this.selectTableData.map(function (val, i) {
              params.otherIds.push(val.otherId);
            });
            this.$API.delOtherOut(params).then((r) => {
              if (r.data.status === "success") {
                this.GetData();
                this.$message.success(r.data.message);
              }
            });
          })
          .catch((err) => {
            if (data) this.selectTableData.length = 0;
          });
      }
    },
    // 表格设置
    SetTable() {
      this.$TOOLS.myModel(this);
    },

    // 查询事件
    queryBtn_ok() {
      this.GetData();
    },
    // 表格右侧按钮回调事件
    rowCallback(data, name) {
      this[name](data);
    },
    // 表格选择事件
    handleSelectionChange(e) {
      this.selectTableData = e;
    },

    goYdDetails(a) {
      this.$message.success("你点我干嘛");
    },
  },
};
</script>
  <style scoped lang="less">
</style>
                    